const footer = {
    footer:{
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        refund: 'Refund Policy',
    }
  };
  
  export default footer;